export function repeat(i, arr, times, val) {
  for (let x = 0; x < times; x++) {
    arr[i + x] = val;
  }
}

export function setVector(i, arr, vec) {
  for (let x = 0; x < vec.length; x++) {
    arr[i + x] = vec[x];
  }
}

export function repeatVector(vec, times) {
  const size = vec.length;
  const res = new Array(size * times);
  for (let x = 0; x < times; x++) {
    for (let y = 0; y < size; y++) {
      res[x * size + y] = vec[y];
    }
  }
  return res;
}

export function repeatVectorInline(vec, times, arr, startInd) {
  const size = vec.length;
  for (let x = 0; x < times; x++) {
    for (let y = 0; y < size; y++) {
      arr[startInd + x * size + y] = vec[y];
    }
  }
}

export function addTri(i, arr, a, b, c) {
  setVector(i, arr, a);
  setVector(i + 3, arr, b);
  setVector(i + 6, arr, c);
}

export function addRect(i, arr, a, b, c, d) {
  addTri(i, arr, a, b, c);
  addTri(i + 9, arr, c, d, b);
}

export function addRectIndexed(i, arr, a, b, c, d) {
  addTri(i, arr, a, b, c);
  setVector(i + 9, arr, d);
}
